import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useState, useEffect, useCallback } from 'react';
import { GooglePSEService, GooglePSEApiError } from './service';
export var useGooglePSE = function useGooglePSE() {
    var _useState = useState(null), data = _useState[0], setData = _useState[1];
    var _useState2 = useState(false), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = useState(null), error = _useState3[0], setError = _useState3[1];
    var _useState4 = useState(function () {
        return new GooglePSEService();
    }), service = _useState4[0];
    var search = useCallback(/*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(params) {
            var response;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context.prev = 2;
                            _context.next = 5;
                            return service.searchWithRetry(params);
                        case 5:
                            response = _context.sent;
                            setData(response);
                            _context.next = 12;
                            break;
                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](2);
                            setError(_context.t0 instanceof GooglePSEApiError ? _context.t0 : new GooglePSEApiError(500, _context.t0.message));
                        case 12:
                            _context.prev = 12;
                            setLoading(false);
                            return _context.finish(12);
                        case 15:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[2, 9, 12, 15]]);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }(), [service]);
    var searchPaginated = useCallback(/*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(params, page, pageSize) {
            var response;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (pageSize === void 0) {
                                pageSize = 10;
                            }
                            setLoading(true);
                            setError(null);
                            _context2.prev = 3;
                            _context2.next = 6;
                            return service.searchPaginated(params, page, pageSize);
                        case 6:
                            response = _context2.sent;
                            setData(response);
                            _context2.next = 13;
                            break;
                        case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](3);
                            setError(_context2.t0 instanceof GooglePSEApiError ? _context2.t0 : new GooglePSEApiError(500, _context2.t0.message));
                        case 13:
                            _context2.prev = 13;
                            setLoading(false);
                            return _context2.finish(13);
                        case 16:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, null, [[3, 10, 13, 16]]);
        }));
        return function (_x2, _x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }(), [service]);
    var clear = useCallback(function () {
        setData(null);
        setError(null);
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        search: search,
        searchPaginated: searchPaginated,
        clear: clear
    };
};
export var useGooglePSEDebounced = function useGooglePSEDebounced(query, options) {
    var _useState5 = useState(query), debouncedQuery = _useState5[0], setDebouncedQuery = _useState5[1];
    var googlePSE = useGooglePSE();
    useEffect(function () {
        var timer = setTimeout(function () {
            setDebouncedQuery(query);
        }, options.debounceMs || 300);
        return function () {
            return clearTimeout(timer);
        };
    }, [query, options.debounceMs]);
    useEffect(function () {
        if (debouncedQuery && debouncedQuery.trim() && options.autoSearch) {
            googlePSE.search(Object.assign({
                query: debouncedQuery
            }, options.searchParams));
        }
    }, [debouncedQuery, options.autoSearch, options.searchParams, googlePSE]);
    return googlePSE;
};
